<!-- 表1填写 -->

<template>
  <div class="tabCage ssTab1E">
    <div class="tabTtl">
      <span>出版物基本信息</span>
    </div>

    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">出版物中文名称：</td>
            <td class="edInp">
              <el-form-item prop="publication" :inline-message="true">
                <el-input v-model="params.publication" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">出版物外文名称：</td>
            <td class="edInp">
              <el-form-item prop="publicationEnglish" :inline-message="true">
                <el-input v-model="params.publicationEnglish" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td class="edName">类别：</td>
            <td class="edInp">
              <el-form-item prop="category" :inline-message="true">
                <el-select v-model="params.category" size="small" disabled placeholder="请选择">
                  <el-option v-for="item in dicDats['C026']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">文种：</td>
            <td class="edInp">
              <el-form-item prop="recordType" :inline-message="true">
                <el-input v-model="params.recordType" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">刊期：</td>
            <td class="edInp">
              <el-form-item prop="periodicals" :inline-message="true">
                <el-select v-model="params.periodicals" disabled size="small" placeholder="请选择">
                  <el-option v-for="item in dicDats['C014']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">刊号（CN）：</td>
            <td class="edInp">
              <el-form-item prop="cn" :inline-message="true">
                <el-input v-model="params.cn" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">国际刊号（ISSN）：</td>
            <td class="edInp">
              <el-form-item prop="issn" :inline-message="true">
                <el-input v-model="params.issn" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">批准时间：</td>
            <td class="edInp">
              <el-form-item prop="approvalTime" :inline-message="true">
                <el-date-picker disabled v-model="params.approvalTime" value-format="yyyy-MM-dd" size="small">
                </el-date-picker>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td class="edName">批复文件：</td>
            <td class="edInp">
              <el-button v-if="params.applyFileId" size="mini" type="warning" @click="filesDown(params.applyFileId)" >
                下载
              </el-button>
              <span v-if="!params.applyFileId" size="mini" type="danger"  style="color:red;">
                未上传
              </span>
              <!-- <div class="tips" style="margin-top:5px;line-height:20px;">
                <span style="color:red">注：</span>请上传国家出版行政管理部门同意创办的批复文件，如有特殊情况无法上传，
                <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                请对无法上传情况进行说明，上传加盖社章的说明文件。
                <br>
              </div> -->
              <!-- <div class="tips" style="margin-top:-24px;"></div> -->
            </td>
          </tr>
          <tr>
            <td class="edName">媒体形态：</td>
            <td class="edInp">
              <el-form-item prop="mediaForm" :inline-message="true">
                <el-select v-model="params.mediaForm" disabled size="small" placeholder="请选择">
                  <el-option v-for="item in dicDats['C025']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <!-- <tr v-if="numShow">
            <td class="edName">发行数量(套)：</td>
            <td class="edInp">
              <el-form-item prop="issueQuantity" :inline-message="true">
                <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.issueQuantity"
                  disabled size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr v-if="numShow">
            <td class="edName">发行单价(元)：</td>
            <td class="edInp">
              <el-form-item prop="unitPrice" :inline-message="true">
                <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.unitPrice" disabled
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr> -->
          <tr>
            <td class="edName">是否缴送样本：</td>
            <td class="edInp">
              <el-form-item prop="isSampleDelivery" :inline-message="true">
                <el-select v-model="params.isSampleDelivery" size="small" disabled placeholder="请选择">
                  <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">出版范围：</td>
            <td class="edInp">
              <el-form-item prop="publicationScope" :inline-message="true">
                <el-input type="textarea" :rows="3" v-model="params.publicationScope" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">发行范围：</td>
            <td class="edInp">
              <el-form-item prop="issueScope" :inline-message="true">
                <el-input type="textarea" :rows="3" v-model="params.issueScope" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">读者对象：</td>
            <td class="edInp">
              <el-form-item prop="readers" :inline-message="true">
                <el-input type="textarea" :rows="3" v-model="params.readers" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
        </table>
        <div class="headBar">
          <span>申报人信息</span>
        </div>
        <div class="editArea">
          <table>
            <tr>
              <td class="edName">申报人：</td>
              <td class="edInp">
                <el-input disabled v-model="declare.personnel" size="small" placeholder="请输入申报人"></el-input>
              </td>
            </tr>
            <tr>
              <td class="edName">联系方式：</td>
              <td class="edInp">
                <el-input disabled v-model="declare.contact" size="small" placeholder="请输入申报人联系方式"></el-input>
              </td>
            </tr>
            <tr>
              <td class="edName">申报时间：</td>
              <td class="edInp">
                <el-input v-model="params.updatedAt" size="small" :disabled="true"></el-input>
              </td>
            </tr>
          </table>
        </div>
      </div>

    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>

  </div>
</template>

<script>
  import {
    bsParams,
    paramsRule
  } from '@/components/LongParams/paramsSEt1';
  import { getPfileUrl } from '@/api/pressRole/pressRole';
  import {
    ssSave1,
    ssRead1
  } from '@/api/pressRole/pressSuccessive';
  import UpbtnPdf from '@/views/components/uploadPdf';
  export default {
    components: {
      UpbtnPdf,
    },
    data() {
      return {
        params: bsParams,
        rules: paramsRule,
        numShow: false,
        mediaType: {},
        dicDats: {},
        isNot: {},
        submiting: false,
        layDasion: 1,

        declare: {
          personnel: "",
          contact: ""
        },
      }
    },

    methods: {
      filesDown: function(dat){
        console.log('批复文件：',dat)
        getPfileUrl({id: dat}).then(response => {
          let url = response.payload.url
          console.log('url=',url);
          
          window.open(url);
        })
      },
      editSave: function (name) {

        this.$refs[name].validate((valid) => {
          if (valid) {
            this.params.publishId = this.$route.query.pressId;
            this.params.publishMaterialId = this.$route.query.mtId;
            ssSave1({
              plxdzPublication: this.params
            }).then(response => {
              this.submiting = false;
              this.$message({
                message: '保存成功！',
                type: 'success'
              });
              for (let key in this.params) {
                this.params[key] = '';
              };
              this.$router.push({
                path: 'successive_tabs',
                query: {
                  mtId: this.$route.query.mtId
                }
              });
            }).catch(error => {
              this.submiting = false;
            })
          } else {
            return false;
          }
        })
      },

      dictInit: function () {
        let nameArr = ['C026', 'C014', 'C025', 'C018'];
        let newPromise = this.$store.dispatch('dictUpdate', {
          codeArr: nameArr,
          type: 'arr'
        });
        newPromise.then(result => {
          this.dicDats = result;
          this.isNot = this.$store.getters.dictionary['C018'];
          this.mediaType = this.$store.getters.dictionary['C025'];

          if (this.$route.query.pgress == 2) {
            this.tabReEdit();
          }
        });

      },

      tabReEdit: function () {
        let vm = this;
        ssRead1({
          publishMaterialId: this.$route.query.mtId
        }).then(response => {
          console.log('>>>', response);
          this.params = response.plxdzPublication;
          
          this.declare.contact = response.pOrganizationPersonnel.contact;
          this.declare.personnel = response.pOrganizationPersonnel.personnel;
          this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

          if (vm.mediaType[vm.params.mediaForm] == '电子-信息网络出版') {
            vm.numShow = false;
            vm.params.issueQuantity = 0;
            vm.params.unitPrice = 0;
          } else {
            vm.numShow = true;
          }
        })
      },

      fileTdSet: function (id) {
        this.params.yyzzId = id;
      },

      layChange: function () {
        if (this.isNot[this.params.isIndependentLP] == "是") {
          this.layDasion = 1;
        } else {
          this.layDasion = 2;
        }
      },

      goBack: function () {
        this.$router.go(-1);
      }
    },
    created: function () {
      this.dictInit();

    }
  }
</script>

<style lang="scss">
  @import "src/styles/pressRoleE";

  .ssTab1E {
    margin-top: 0px;

    .edInp .el-input-number {
      width: 300px;
    }

    .el-textarea {
      width: 450px;
    }
  }

  .el-date-editor {
    border-radius: 0px;
  }
</style>


// WEBPACK FOOTER //
// ssTab1.vue?776613ba